import { FileSearchOutlined } from '@ant-design/icons';
import { find, includes } from 'lodash';
import React, { Fragment } from 'react';
import { generateUserWebCategoryPageUrl } from '../../lib/utils/categoryUtils';
import Button from '../Button';
import Input from '../input/Input/Input';
import Select from '../input/Select';
import Anchor from '../link/Anchor';
import { ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_INFO_LIST } from '../../constants/service/app/widgetConstants';
import { APP_LINK_TYPE } from '../../constants/service/common/commonConstants';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  WIDGET_ITEM_LIST_FILTER_OPTION_MODEL,
  WIDGET_ITEM_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/widget/models';

class GlobalLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      link: this.props.value,
    };
  }

  setLink = (link) => {
    this.setState({ link });

    if (this.props.onChange) {
      this.props.onChange(link);
    }
  };

  toggleModal = (data) => {
    this.props.toggleModal(data);
  };

  appToggleModal = (data) => {
    this.props.appToggleModal(data);
  };

  linkIdButton = (linkType, linkId, toggleModal, name) => {
    /**
     * 링크 ID 를 선택하는 모달이 필요한 링크 타입 체크(링크 타입이 브랜드(1), 기획전(2), 상품 상세(16), 후기 상세(17), 태그 상세(19,20) 홈 페이지(2000) 일경우)
     */
    const needSearchModalData = find(
      ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_INFO_LIST,
      (item) => item.id === linkType,
    );

    /**
     * 링크 ID 를 선택하는 모달이 필요한 링크인 경우에는
     * 링크 ID 를 선택할 수 있는 모달을 열수 있는 버튼을 만들어야 함
     */
    if (needSearchModalData) {
      /**
       * 검색하는 모달의 widgetType 이 있다면 filterOption, sortOption 을 추가하기
       */
      const optionData = {};

      /**
       *  필터 옵션
       */
      if (WIDGET_ITEM_LIST_FILTER_OPTION_MODEL[linkType]) {
        optionData.filterOption = WIDGET_ITEM_LIST_FILTER_OPTION_MODEL[linkType];
      }

      /**
       *  정렬 옵션
       */
      if (WIDGET_ITEM_LIST_SORT_OPTION_MODEL[linkType]) {
        optionData.sortOption = WIDGET_ITEM_LIST_SORT_OPTION_MODEL[linkType];
      }

      /**
       * 링크 ID 를 선택할 수 있는 모달에 넣어줄 DATA SET 만들기
       */
      const setData = (linkId) => {
        return {
          name: needSearchModalData.targetModal,
          data: {
            /**
             * 변경해야 할 STORE PATH
             */
            targetPath: ['tempModalData'],
            /**
             * 리스트를 받아오는 STORE PATH
             */
            listPath: [needSearchModalData.targetModal, 'data', 'listData'],
            listData: {
              list: [],
              ...optionData,
              pagination: LIST_PAGINATION_MODEL,
            },
            selectedId: linkId,
            linkType,
            attachment: [],
          },
          value: true,
        };
      };

      /**
       * 링크 ID 가 선택되어졌을 경우에는 편집을 할 수 있도록 함
       */
      if (linkId && needSearchModalData) {
        return (
          <Anchor
            isUnderLine
            color="primary"
            onClick={() => toggleModal(setData(linkId))}
            text={`${name}(${linkId})`}
          />
        );
      } else if (needSearchModalData) {
        /**
         * 링크 ID 를 선택 할 수 있도록 하는 모달을 열 수 있는 버튼을 만듦
         */
        return <Button type="button" text="ID 선택" color="primary" onClick={() => toggleModal(setData(null))} />;
      }
    } else return <></>;
    /**
     * 링크 ID 를 선택하지 않은 링크 타입인 경우에는
     * - 으로 보여주고 등록을 하게 되었을 때,
     * DB 의 Banner.linkId 컬럼에는 null 로 저장이 됨
     */
  };

  handleLinkTypeChange = (value) => {
    this.setLink({
      ...this.state.link,
      linkType: value,
      linkId: null,
      linkUrl: '',
    });
  };

  handleLinkUrlChange = (value) => {
    this.setLink({
      ...this.state.link,
      linkUrl: value,
    });
  };

  handleCategoryLinkUrlChange = (value) => {
    const { mainProductCategory, subProductCategory } = value;
    const subProductCategoryIdList = subProductCategory.map((item) => item.id);

    const targetUrl = generateUserWebCategoryPageUrl(mainProductCategory.id, subProductCategoryIdList);

    this.setLink({
      ...this.state.link,
      linkUrl: targetUrl,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.tempModalData !== this.props.tempModalData) {
      this.setLink({
        ...this.state.link,
        linkId: this.props.tempModalData.linkId,
        linkName: this.props.tempModalData.linkName,
      });
    }
  }

  render() {
    const { toggleModal, appToggleModal } = this.props;
    const { link } = this.state;

    return (
      <div>
        <div>
          <Select list={this.props.list} value={link.linkType} onChange={this.handleLinkTypeChange} />
        </div>

        {link.linkType !== APP_LINK_TYPE.WEB_PAGE && (
          <div style={{ lineHeight: '21px' }}>
            {this.linkIdButton(link.linkType, link.linkId, toggleModal, link.linkName)}
          </div>
        )}

        {includes([APP_LINK_TYPE.WEB_PAGE, APP_LINK_TYPE.CATEGORY_PAGE], link.linkType) && (
          <Fragment>
            <Input value={link.linkUrl} onChange={this.handleLinkUrlChange} />
            {link.linkType === APP_LINK_TYPE.CATEGORY_PAGE && (
              <div className="product-category-search-btn-wrap">
                <span>유저 웹 상품 카테고리 페이지 URL 설정</span>
                <FileSearchOutlined
                  className="product-category-search-btn"
                  onClick={() =>
                    appToggleModal({
                      name: 'searchProductCategoryModal',
                      data: {
                        listData: {
                          list: [],
                        },
                        setData: (data) => this.handleCategoryLinkUrlChange(data),
                      },
                    })
                  }
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default GlobalLink;
